import { useContext } from "react";
import { AppContext } from "../App";
import logo from "./../images/logo.png";

function Lock() {
	const { loadingMessage, loadingError } = useContext(AppContext);

	return (
		<div className="lock">
			<div className="content">
				<img src={logo} />
				<div>{loadingMessage || "Loading ..."}</div>
				{loadingError && <div className="text-error">{loadingError}</div>}
			</div>
		</div>
	);
}

export default Lock;
